var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "details-view",
      staticStyle: { overflow: "auto" },
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SystemMaintenance.SetOpInstruction"),
        width: "1000px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "main-content",
          staticStyle: { height: "455px", overflow: "auto" }
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { width: "502px" },
              attrs: { "label-width": "100px" }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("SystemMaintenance.CommandApplication")
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        display: "flex",
                        "align-items": "center"
                      }
                    },
                    [
                      _c("el-checkbox", {
                        staticStyle: { "margin-right": "5px" },
                        attrs: { disabled: _vm.readonly },
                        on: { change: _vm.onUseHqSet },
                        model: {
                          value: _vm.instructionManage.useHqSet,
                          callback: function($$v) {
                            _vm.$set(_vm.instructionManage, "useHqSet", $$v)
                          },
                          expression: "instructionManage.useHqSet"
                        }
                      }),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_GeneralSettings")))
                      ]),
                      !_vm.formDisabale
                        ? _c("i", {
                            staticClass: "el-icon-circle-plus",
                            staticStyle: {
                              color: "#42b983",
                              cursor: "pointer",
                              "font-size": "18px",
                              "margin-left": "auto",
                              "margin-right": "20px"
                            },
                            on: { click: _vm.add }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _vm._l(_vm.instructionList, function(item, index) {
            return _c(
              "div",
              {
                key: _vm.getKey(_vm.instructionList.length, index),
                staticStyle: { "margin-top": "15px" }
              },
              [
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: { width: "502px" },
                        attrs: {
                          disabled: _vm.formDisabale,
                          "label-width": "100px"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            key:
                              "selectInstruction" +
                              _vm.getKey(_vm.instructionList.length, index)
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "title",
                                staticStyle: { "font-size": "12px" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_SelectInstruction")
                                  )
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "100%",
                                  display: "flex",
                                  "align-items": "center"
                                }
                              },
                              [
                                _c("tenant-instruction-dialog", {
                                  staticStyle: { width: "350px" },
                                  attrs: {
                                    "input-width": "100%",
                                    lob: _vm.lob,
                                    "is-apply-ui-custom": true,
                                    value: item.tenantInstructionUuid,
                                    "tenant-instructions":
                                      _vm.tenantInstructions
                                  },
                                  on: {
                                    change: function(p) {
                                      return _vm.tenantInstructionChange(
                                        p,
                                        item
                                      )
                                    }
                                  }
                                }),
                                !_vm.formDisabale
                                  ? _c("i", {
                                      staticClass: "el-icon-remove",
                                      staticStyle: {
                                        color: "#f56c6c",
                                        cursor: "pointer",
                                        "font-size": "18px",
                                        "margin-left": "auto",
                                        "margin-right": "20px"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.remove(item)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            key:
                              "commandParameters" +
                              _vm.getKey(_vm.instructionList.length, index),
                            attrs: {
                              label: _vm.$t(
                                "SystemMaintenance.CommandParameters"
                              )
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "350px" },
                              attrs: { type: "textarea", rows: 3 },
                              model: {
                                value: item.instructionParam,
                                callback: function($$v) {
                                  _vm.$set(item, "instructionParam", $$v)
                                },
                                expression: "item.instructionParam"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            key:
                              "SceneRules" +
                              _vm.getKey(_vm.instructionList.length, index),
                            attrs: {
                              label: _vm.$t("SystemMaintenance.SceneRules")
                            }
                          },
                          [
                            _c("specific-business-rule-dialog", {
                              staticStyle: { width: "350px" },
                              attrs: {
                                "input-width": "100%",
                                lob: _vm.lob,
                                "apply-ui-custom": true,
                                "specific-business-rule-uuid":
                                  item.specificBusinessRuleUuid,
                                "specific-business-rules":
                                  _vm.specificBusinessRules
                              },
                              on: {
                                change: function(p) {
                                  return _vm.specificBusinessRuleChange(p, item)
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            key:
                              "sceneParameters" +
                              _vm.getKey(_vm.instructionList.length, index),
                            attrs: {
                              label: _vm.$t("SystemMaintenance.SceneParameters")
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "350px" },
                              attrs: { type: "textarea", rows: 3 },
                              model: {
                                value: item.ruleParam,
                                callback: function($$v) {
                                  _vm.$set(item, "ruleParam", $$v)
                                },
                                expression: "item.ruleParam"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form",
                      {
                        staticStyle: {
                          "flex-grow": "1",
                          "margin-right": "20px"
                        },
                        attrs: {
                          disabled: _vm.formDisabale,
                          "label-width": "80px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            key:
                              "permission" +
                              _vm.getKey(_vm.instructionList.length, index)
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "title",
                                staticStyle: { "font-size": "12px" },
                                attrs: { slot: "label" },
                                slot: "label"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "SystemMaintenance.InstructionPermissions"
                                    )
                                  )
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "el-form-item",
                          {
                            key:
                              "allPosition" +
                              _vm.getKey(_vm.instructionList.length, index),
                            staticStyle: { "margin-left": "15px" },
                            attrs: { "label-width": "0" }
                          },
                          [
                            _c(
                              "el-checkbox",
                              {
                                on: {
                                  change: function($event) {
                                    return _vm.onAllPositionChange(item)
                                  }
                                },
                                model: {
                                  value:
                                    item.instructionPermissionJson.allPosition,
                                  callback: function($$v) {
                                    _vm.$set(
                                      item.instructionPermissionJson,
                                      "allPosition",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "item.instructionPermissionJson.allPosition"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SystemMaintenance.AllPositions2")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            key:
                              "position" +
                              _vm.getKey(_vm.instructionList.length, index),
                            staticStyle: { "margin-left": "15px" },
                            attrs: {
                              label: _vm.$t(
                                "SystemMaintenance.DesignatedPosition"
                              )
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                disabled:
                                  item.instructionPermissionJson.allPosition,
                                "callback-method-type": "value",
                                multiple: "",
                                "default-multiple-value": _vm.toArray(
                                  item.instructionPermissionJson
                                    .multipleSpecifiedPosition
                                ),
                                filterable: "",
                                "static-options": _vm.positionOptions,
                                "tag-name": "label",
                                "tag-value": "positionField",
                                "filter-tag-names": ["positionField", "label"]
                              },
                              on: {
                                parentCallBack: function(value) {
                                  item.instructionPermissionJson.multipleSpecifiedPosition = _vm.toTxt(
                                    value
                                  )
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            key:
                              "person" +
                              _vm.getKey(_vm.instructionList.length, index),
                            staticStyle: { "margin-left": "15px" },
                            attrs: {
                              label: _vm.$t(
                                "CargoMsg.Cargo_DesignatedPersonnel"
                              )
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                "select-type": _vm.TYPE_NAMES.basic_data_User,
                                "callback-method-type": "value",
                                multiple: "",
                                "default-multiple-value": _vm.toNumArray(
                                  item.multipleSpecifiedPerson
                                ),
                                filterable: ""
                              },
                              on: {
                                parentCallBack: function(value) {
                                  item.multipleSpecifiedPerson = _vm.toTxt(
                                    value
                                  )
                                }
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                index < _vm.instructionList.length - 1
                  ? _c("div", {
                      staticClass: "el-divider el-divider--horizontal",
                      staticStyle: {
                        margin: "10px 0 0 10px",
                        width: "calc(100% - 25px)"
                      }
                    })
                  : _vm._e()
              ]
            )
          })
        ],
        2
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.okHandler } },
            [_vm._v(_vm._s(_vm.$t("Message.Confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }